/**
 * Portal Types reducer.
 * @module reducers/portalTypes/portalTypes
 */

import { GET_PORTAL_TYPES } from '../../constants/ActionTypes';

const initialState = {
  items: [],
  loading: false,
  loaded: false,
  error: null,
  total: 0,
};

/**
 * Portal Types reducer.
 * @function portalTypes
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export default function portalTypes(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_PORTAL_TYPES}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    case `${GET_PORTAL_TYPES}_SUCCESS`:
      return {
        ...state,
        items: action.result.items || [],
        total: action.result.total || 0,
        loading: false,
        loaded: true,
        error: null,
      };
    case `${GET_PORTAL_TYPES}_FAIL`:
      return {
        ...state,
        items: [],
        total: 0,
        loading: false,
        loaded: false,
        error: action.error,
      };
    default:
      return state;
  }
}
